<script lang="ts">
  import LinearProgress from './base/LinearProgress.svelte'
  import { navigating } from '$app/stores'
  import type { Theme } from '../types/theme'

  export let src: string
  export let srcOnly: boolean | undefined = undefined
  export let storedTheme: Theme | undefined = undefined
  export let href: string | undefined = undefined
  export let fullWidth: boolean | undefined = undefined
</script>

<LinearProgress indeterminate fixed active={Boolean($navigating)} />
<div class="header">
  <a href={href || '/'}>
    <picture>
      {#if storedTheme}
        <source srcset={src} />
      {/if}
      {#if !srcOnly}
        <source
          srcset="/images/bruce-studios-logo-white.svg"
          media="(prefers-color-scheme: dark)"
        />
        <source
          srcset="/images/bruce-studios-logo-black.svg"
          media="(prefers-color-scheme: light)"
        />
      {/if}
      <img {src} alt="Bruce Studios" />
    </picture>
  </a>
</div>
<main class:fullWidth>
  <slot />
</main>

<style lang="scss">
  @use '@bond/assets/css/breakpoints';

  .header {
    display: flex;
    justify-content: center;
    padding: 32px 0 0 0;
    width: 100%;

    img {
      display: block;
      height: 30px;
    }
  }

  main {
    max-width: 480px;
    padding: 0 32px;
    margin: 0 auto 4em auto;
    text-align: center;
    background-color: var(--color-background);

    &.fullWidth {
      max-width: 100%;
      padding: 0;
    }

    @media screen and (min-width: breakpoints.$breakpoint-sm) {
      min-width: 480px;
    }

    :global(form:not([hidden])),
    :global(fieldset:not([hidden])) {
      display: flex;
      flex-direction: column;
      gap: var(--field-gap);
    }
  }
</style>
